<template>
  <div class="">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <el-form-item label="上传图片">
        <el-upload
          class="avatar-uploader"
          action="/inqiye/upload"
          :show-file-list="true"
          :on-success="handleSuccess"
          :before-upload="beforeUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('ruleForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  export default {
    name: '',
    data(){
      return {
        ruleForm:{
          title:"",
          desc:""
        },
        rules:{
          title: [
            { required: true, message: '标题不能为空', trigger: 'blur' },
            { min: 0, max: 254, message: '长度在 0 到 254 个字符', trigger: 'blur' }
          ],
          desc: [
            { required: true, message: '描述不能为空', trigger: 'blur' },
            { min: 0, max: 1024, message: '长度在 0 到 1024 个字符', trigger: 'blur' }
          ],
        },
        imageUrl: "",
      }
    },
    components: {

    },
    computed:{

    },
    methods:{
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let postData = {
              title:this.ruleForm.title,
              desc:this.ruleForm.desc,
              url:this.imageUrl
            };
            if(!this.imageUrl){
              this.$message.error('请上传图片');
              return false
            };
            this.$emit("ReceiveEvent",postData)
          } else {
            //验证失败
            return false;
          }
        });

      },
      handleSuccess(res, file) {
        this.imageUrl =  res.url;
      },
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isLt2M;
      }
    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style scoped>
  .avatar-uploader{
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    text-align: left;
    background: #fff;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar-uploader-icon{
    background: #fff;
  }
</style>
